<template>
  <a-modal
    title="AI语音模型配置"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
          }"
                    ref="ruleForm"
                    :rules="rules"
      >
        <a-form-model-item
          prop="wechat"
          label="是否开启AI语音模型核查">
          <a-radio-group v-model="model.voice" >
            <a-radio-button value="1">
              是
            </a-radio-button>
            <a-radio-button value="0">
              否
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          prop="wechat"
          v-if="model.voice==='1'"
          label="选择语音模型">
          <a-select
          placeholder="请选择"
          mode="multiple"   
          v-model="model.voiceIds"
          :filterOption="filterOption">
          <a-select-option :value="item.name" v-for="item in voiceModelList" :key="item.id">
          {{ item.name }}
        </a-select-option>
        </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction,getAction,putAction,postAction } from '@/api/manage'
  export default {
    name: 'VoiceConfig',
    data(){
      return {
        rules:{},
        confirmLoading:false,
        visible:false,
        model:{
                voiceIds: []  // 初始化为数组
              },
        voiceModelList:[],
      }
    },
    methods:{
      view(project){
        this.model = Object.assign({},project)
        this.visible = true
        getAction('/project/voiceConfig/getConfigAll').then(res=>{
          if(res.success){
            this.voiceModelList = res.result
          }
        })
      },
      handleOk(){    
        console.log(11 ,this.model)
        console.log(22 ,this.voiceModelList)
    
        // 初始化语音项数组
        let voiceItems=[]
        this.model.voiceIds.forEach(item=>{
          let voiceItem=this.voiceModelList.find(v=>v.name==item)
          voiceItem.projectId=this.model.id
          voiceItem.id=null
          voiceItems.push(voiceItem)
        })
        postAction('/project/voiceConfig/addByList',voiceItems).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.$emit('ok')
            this.handleCancel()
          }
        })

      },
      handleCancel(){
        this.visible = false
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
    }
  }
</script>

<style scoped>

</style>